export default () => ({
  root: {
    'white-space': 'nowrap',
    maxWidth: props => props.maxWidth || 'inherit',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
});
